// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2324": "aa022e97","7039": "5ebb1ed2","7167": "52f82b6c",}[chunkId] + ".css"
}